/* Lumiva — landing sections behaviour (UGC slider, offer timer, reviews, FAQ, lazy video).
   Every initialiser is idempotent and scoped to a root, so it works with several
   instances and with theme-editor section reloads. */
(function () {
  "use strict";

  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = "1";
    return true;
  }

  /* ---------------- UGC quote slider ---------------- */
  function initUgc(sec) {
    if (!once(sec, "lvInit")) return;
    var track = sec.querySelector("[data-track]");
    if (!track) return;
    var slides = $$("[data-slide]", track);
    var n = slides.length;
    var ctr = sec.querySelector("[data-ctr]");
    var ms = (parseInt(sec.dataset.autoplay, 10) || 0) * 1000;
    var i = 0;
    var timer = null;

    function go(k) {
      i = (k + n) % n;
      track.style.transform = "translateX(-" + i * 100 + "%)";
      slides.forEach(function (s, j) {
        s.setAttribute("aria-hidden", j === i ? "false" : "true");
      });
      if (ctr) ctr.textContent = i + 1 + " / " + n;
    }
    function auto() {
      clearInterval(timer);
      if (ms && n > 1 && !reduceMotion && !(window.Shopify && window.Shopify.designMode)) {
        timer = setInterval(function () {
          go(i + 1);
        }, ms);
      }
    }
    var prev = sec.querySelector("[data-prev]");
    var next = sec.querySelector("[data-next]");
    prev &&
      prev.addEventListener("click", function () {
        go(i - 1);
        auto();
      });
    next &&
      next.addEventListener("click", function () {
        go(i + 1);
        auto();
      });

    var x0 = null;
    track.addEventListener(
      "touchstart",
      function (e) {
        x0 = e.touches[0].clientX;
      },
      { passive: true },
    );
    track.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) {
        go(i + (dx < 0 ? 1 : -1));
        auto();
      }
      x0 = null;
    });

    sec._lvGo = function (idx) {
      go(idx);
      clearInterval(timer);
    };
    go(0);
    auto();
  }

  /* ---------------- offer bar mini countdown ---------------- */
  function endOfDay() {
    var d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }
  function pad(v) {
    return (v < 10 ? "0" : "") + v;
  }
  var timers = [];
  var ticking = false;
  function tickAll() {
    var deadline =
      (window.Lumiva && Number(window.Lumiva.deadline)) || endOfDay();
    var left = Math.max(0, deadline - Date.now());
    if (left === 0 && !(window.Lumiva && window.Lumiva.deadline)) {
      left = endOfDay() - Date.now();
    }
    var t = Math.floor(left / 1000);
    var h = pad(Math.floor(t / 3600));
    var m = pad(Math.floor((t % 3600) / 60));
    var s = pad(t % 60);
    timers = timers.filter(function (el) {
      return document.contains(el);
    });
    timers.forEach(function (el) {
      el.querySelector("[data-h]").textContent = h;
      el.querySelector("[data-m]").textContent = m;
      el.querySelector("[data-s]").textContent = s;
    });
  }
  function initTimers(root) {
    $$("[data-lv-mini-timer]", root).forEach(function (el) {
      if (!once(el, "lvInit")) return;
      timers.push(el);
    });
    if (timers.length && !ticking) {
      ticking = true;
      setInterval(tickAll, 1000);
    }
    tickAll();
  }

  /* ---------------- reviews: show more ---------------- */
  /* Review form: front-end only for now — validates and shows a thank-you. */
  function initReviewForm(sec) {
    var dlg = sec.querySelector("[data-rv-dialog]");
    var open = sec.querySelector("[data-rv-open]");
    if (!dlg || !open) return;
    var form = dlg.querySelector("[data-rv-form]");
    var ok = dlg.querySelector("[data-rv-ok]");
    var err = dlg.querySelector("[data-rv-err]");
    function show() {
      form.hidden = false;
      ok.hidden = true;
      err.hidden = true;
      if (dlg.showModal) dlg.showModal();
      else dlg.setAttribute("open", "");
      document.body.classList.add("lock");
    }
    function hide() {
      if (dlg.close) dlg.close();
      else dlg.removeAttribute("open");
    }
    dlg.addEventListener("close", function () {
      document.body.classList.remove("lock");
    });
    open.addEventListener("click", show);
    $$("[data-rv-close]", dlg).forEach(function (b) {
      b.addEventListener("click", hide);
    });
    dlg.addEventListener("click", function (e) {
      if (e.target === dlg) hide();
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var msg = "";
      if (!form.querySelector('input[name="rating"]:checked'))
        msg = "Please choose a star rating.";
      else if (!form.checkValidity())
        msg = "Please fill in all required fields with a valid email.";
      if (msg) {
        err.textContent = msg;
        err.hidden = false;
        return;
      }
      form.reset();
      form.hidden = true;
      ok.hidden = false;
    });
  }

  function initReviews(sec) {
    if (!once(sec, "lvInit")) return;
    initReviewForm(sec);
    var btn = sec.querySelector("[data-more]");
    var list = sec.querySelector("[data-list]");
    if (!btn || !list) return;
    btn.addEventListener("click", function () {
      var all = list.classList.toggle("is-all");
      btn.textContent = all ? btn.dataset.lessLabel : btn.dataset.moreLabel;
      btn.setAttribute("aria-expanded", all ? "true" : "false");
    });
  }

  /* ---------------- FAQ accordion (one open at a time) ---------------- */
  function setOpen(item, open) {
    item.classList.toggle("is-open", open);
    var q = item.querySelector(".lv-acc__q");
    if (q) q.setAttribute("aria-expanded", open ? "true" : "false");
  }
  function initAcc(list) {
    if (!once(list, "lvInit")) return;
    list.addEventListener("click", function (e) {
      var q = e.target.closest(".lv-acc__q");
      if (!q || !list.contains(q)) return;
      var item = q.parentNode;
      var was = item.classList.contains("is-open");
      $$(".lv-acc", list).forEach(function (x) {
        setOpen(x, false);
      });
      if (!was) setOpen(item, true);
    });
  }

  /* ---------------- lazy videos (play only while visible) ---------------- */
  var io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              var v = en.target;
              if (en.isIntersecting) {
                if (v.preload === "none") v.preload = "auto";
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                v.pause();
              }
            });
          },
          { rootMargin: "120px 0px" },
        )
      : null;
  function initVideos(root) {
    $$("[data-lv-lazy] video", root).forEach(function (v) {
      if (!once(v, "lvInit")) return;
      v.muted = true;
      v.setAttribute("muted", "");
      v.setAttribute("playsinline", "");
      if (reduceMotion) return;
      if (io) io.observe(v);
      else v.play && v.play();
    });
  }

  /* ---------------- boot ---------------- */
  function init(root) {
    root = root || document;
    $$("[data-lv-ugc]", root).forEach(initUgc);
    $$("[data-lv-reviews]", root).forEach(initReviews);
    $$("[data-lv-acc]", root).forEach(initAcc);
    initTimers(root);
    initVideos(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* theme editor */
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
  document.addEventListener("shopify:block:select", function (e) {
    var block = e.target;
    var sec = block.closest("[data-lv-ugc]");
    if (sec && sec._lvGo && block.hasAttribute("data-slide")) {
      sec._lvGo($$("[data-slide]", sec).indexOf(block));
      return;
    }
    if (block.classList.contains("lv-acc")) {
      var list = block.closest("[data-lv-acc]");
      if (list)
        $$(".lv-acc", list).forEach(function (x) {
          setOpen(x, x === block);
        });
      return;
    }
    if (
      block.classList.contains("lv-rc") &&
      block.classList.contains("is-more")
    ) {
      var rv = block.closest("[data-lv-reviews]");
      var l = rv && rv.querySelector("[data-list]");
      var b = rv && rv.querySelector("[data-more]");
      if (l && !l.classList.contains("is-all") && b) b.click();
    }
  });
})();
